import styled from 'styled-components'

export const SelectWinner = styled.div`
  display: ${props=>props.isOpen ? 'block':'none'};       
`;